import * as React from "react";
import {IconOrImage} from "FormBuilder/Fields/Core/Interfaces/IconOrImage";
import {FormBuilderDesignerModel} from "ProductFieldBuilder/Designer/FormBuilderDesigner/Core/FormBuilderDesigner.Model";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {IconOrImageDisplayer} from "FormBuilder/Fields/Core/SubComponents/IconOrImageDisplayer";
import {CSSProperties, ReactNode} from "react";

export class IconOrImagePlaceholder extends React.Component<IconOrImageDisplayerProps, IconOrImageDisplayerState> {
    static defaultProps: Partial<IconOrImageDisplayerProps> = {
        Color:'#bfbfbf'
    };

    constructor(props: IconOrImageDisplayerProps) {
        super(props);
        this.state = {};
    }

    public render() {
        let iconOrImage=this.props.Icon;
        if(iconOrImage==null||iconOrImage.ImageType=="none")
            return this.props.children(null,'');


        return (
            <div style={{width:'100%',position:'relative'}}>
                <div className={'RNPlaceholderIcon'} style={{display:'inline-block',position:'absolute',height:'100%',left:5,...this.props.styles}}>
                    <IconOrImageDisplayer styles={{color:this.props.Color,...this.props.styles}} icon={this.props.Icon} form={this.props.Model.FormBuilder.ContainerManager.GetRootContainer().ContainerManager.Container}/>
                </div>
                {this.props.children({paddingLeft:27},'RNFocus')}
            </div>
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface IconOrImageDisplayerProps {
    Icon:IconOrImage;
    Model:FBFieldBaseModel;
    Color:string;
    children:(styles?:CSSProperties,classes?:string)=>JSX.Element;
    styles:CSSProperties;
}

interface IconOrImageDisplayerState {

}

//#endregion "My Region"